import React from 'react'

export const SettingNivels = () => {
  return (
    <div>SettingNivels</div>
  )
}
